import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.ButtonRounded {
  font-family: 'Source Sans Pro', Tahoma, sans-serif;
  cursor: pointer;
  font-size: 16px;
  padding: 12px 20px;
  border: 2px solid transparent;
  border-radius: 25px;
  background: ${colors.IconButtonPurple};
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: all .2s ease-in;
  font-weight: bold;
  box-sizing: border-box;
}

.ButtonRounded,
.ButtonRounded:link,
.ButtonRounded:visited,
.ButtonRounded:active {
  color: #f6f6f6;
}

.ButtonRounded:hover,
.ButtonRounded:focus {
  color: #f6f6f6;
  background: ${colors.textHoverPurple};
}

.light {
  border: solid 2px ${colors.primaryText};
  background: #fff;
}

.light,
.light:link,
.light:visited,
.light:active {
  color: ${colors.primaryText};
}

.light:hover,
.light:focus {
  color: ${colors.primaryTextHover};
  border-color: ${colors.primaryTextHover};
  background: #fff;
}

.dark {
  border: solid 2px ${colors.primaryText};
  background: ${colors.baseBg};
}

.dark,
.dark:link,
.dark:visited,
.dark:active {
  color: ${colors.primaryText};
}

.dark:hover,
.dark:focus {
  color: ${colors.primaryText};
  border-color: ${colors.textHoverPurple};
  background: ${colors.textHoverPurple};
}

.full-width {
  width: 100%;
  max-width: none;
}

.has-icon {
  padding-right: 32px;
}

.uppercase {
  text-transform: uppercase;
}

.ButtonRounded :global(svg) {
  padding-left: 12px;
  min-width: 20px;
}

.is-inactive {
  opacity: .4;
  pointer-events: none;
}

@media (min-width: 768px) {
  .ButtonRounded {
    font-size: 24px;
  }
}
`
